/* eslint-disable ember/no-computed-properties-in-native-classes, ember/require-computed-property-dependencies, warp-drive/no-legacy-request-patterns */
import Fragment from 'ember-data-model-fragments/fragment';
import { computed } from '@ember/object';
import { alias } from '@ember/object/computed';
import type { Type } from '@warp-drive/core/types/symbols';
import { attr } from '@warp-drive/legacy/model';
import type Person from '@linc-technologies/linced-common/models/person';

// Proto: groups.Member.
export default class Member extends Fragment {
  declare [Type]: 'groups/member';

  @attr('string', { defaultValue: '' })
  declare personId: string;

  @attr('number', { defaultValue: 0 })
  declare status: number;

  @attr('string', { defaultValue: '' })
  declare externalId: string;

  @computed('personId')
  get person() {
    if (!this.personId) {
      return null;
    }
    return this.store.peekRecord<Person>('person', this.personId);
  }

  @alias('person.fullName')
  declare fullName: string | undefined;
}
